module.exports = __webpack_public_path__ + "img/wallet-04.8ce8ba78.svg";